import React from 'react';
import Image from 'next/image';
import flagBasicNext from '../../svgs/chequered_flag_basic_icon_white.svg';
import { NextImageProps } from '../NextImageProps';

type ExtendedNextImageProps = NextImageProps & {
  color?: 'white';
};
export function FlagBasicNext({ className, width, height, alt, color }: ExtendedNextImageProps) {
  let imageSrc = flagBasicNext;
  if (color) {
    switch (color) {
      case 'white':
        imageSrc = flagBasicNext;
        break;
      default:
        break;
    }
  }
  return (
    <Image width={width} height={height} className={className} src={imageSrc} alt={alt ?? 'Søg'} />
  );
}
